import { Plus } from "lucide-react";

export default function Faq({ items, prefix = "faq" }) {
  return (
    <div className="border-b-2 border-ink">
      {items.map((item, i) => (
        <details key={i} className="group border-t-2 border-ink" open={i === 0}>
          <summary
            data-testid={`${prefix}-question-${i}`}
            className="flex w-full cursor-pointer list-none items-center justify-between gap-6 py-6 text-left [&::-webkit-details-marker]:hidden"
          >
            <span className="flex items-baseline gap-4">
              <span className="font-mono text-[11px] text-accent">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight group-hover:text-accent transition-colors">
                {item.q}
              </span>
            </span>
            <Plus className="h-5 w-5 shrink-0 transition-transform duration-300 group-open:rotate-45 group-open:text-accent" />
          </summary>
          <p data-testid={`${prefix}-answer-${i}`} className="pb-8 pl-10 pr-4 text-sm sm:text-base leading-relaxed text-ink/75 max-w-3xl">
            {item.a}
          </p>
        </details>
      ))}
    </div>
  );
}
